"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const twotimes = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-twotimes` : '') + (description ? ` desc-twotimes` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-twotimes"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-twotimes"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_972_2059)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM12 1.63636C6.27632 1.63636 1.63636 6.27632 1.63636 12C1.63636 17.7237 6.27632 22.3636 12 22.3636C17.7237 22.3636 22.3636 17.7237 22.3636 12C22.3636 6.27632 17.7237 1.63636 12 1.63636ZM8.82545 7.68436C10.6975 7.68436 11.8102 8.90182 11.8102 10.3549C11.8102 11.4545 11.1949 12.3578 10.1738 12.9862L8.52436 14.0073C8.11855 14.256 7.77818 14.5571 7.66036 14.976H11.8625V16.3636H5.72291C5.74909 14.9105 6.25964 13.7716 7.73891 12.8553L9.13964 11.9782C9.89891 11.5069 10.2262 10.9964 10.2262 10.3811C10.2262 9.68727 9.75491 9.05891 8.79927 9.05891C7.80436 9.05891 7.32 9.75273 7.32 10.6298C7.32 10.6735 7.32291 10.72 7.32727 10.768L7.35927 11.0618L5.84073 10.9571C5.82764 10.8393 5.80146 10.6429 5.80146 10.4727C5.80146 9.00655 6.90109 7.68436 8.82545 7.68436ZM14.1469 9.98836C14.1985 10.0743 14.4505 10.4408 14.7275 10.8413L14.967 11.1872C15.2441 11.587 15.4961 11.9504 15.5476 12.0305L16.9353 9.98836H18.6633L16.4247 13.1171L18.7418 16.3636H16.9615L15.4822 14.2298C15.3513 14.4262 14.16 16.1673 14.0422 16.3636H12.3011L14.6182 13.1433L12.3404 9.98836H14.1469Z",
    fill: "inherit"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_972_2059"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var _default = exports.default = twotimes;